module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "mr-navbar-container"
  }, [_c('div', {
    staticClass: "mr-badge"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Madnight Radio")]), _vm._v(" "), _c('span', {
    class: ("fa fa-" + _vm.themeIcon + "-o"),
    on: {
      "click": _vm.toggleTheme
    }
  })], 1), _vm._v(" "), _c('div', {
    class: "mr-hamburger" + (this.hamburgerOpen == true ? " is-active" : ""),
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "mr-navbar-items"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "mr-navbar-item"
    }, [(item.nonRouter !== true) ? _c('router-link', {
      attrs: {
        "to": {
          path: item.link
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58c9908b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/Navbar.vue
// module id = 274
// module chunks = 1